/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { appConstants } from '@app/common/app-constants';
import { StudyDataParam } from '@app/common/services/bring-online/bring-online.types';

export abstract class BringOnline {
  private _inProgress = [];
  private _error = [];

  abstract getBringOnlineStatus(id: any, studyDataParam: StudyDataParam): string;
  abstract getPopupParams(workItem: any): any;
  abstract isOfflineExam(studyDataParam: any): boolean;
  abstract isExamAvailable(workItem: any): boolean;

  updateStatuses(data: any[]): any[] {
    const archiveStatus = [];
    for (const aaExam of data) {
      switch (aaExam.newStatus) {
        case appConstants.archiveAdoptionStatus.InProgress:
          if (this._inProgress.indexOf(aaExam.examCkey) < 0) {
            this._inProgress.push(aaExam.examCkey);
            archiveStatus.push(aaExam);
          }
          break;
        case appConstants.archiveAdoptionStatus.Error:
          this.processError(aaExam);
          archiveStatus.push(aaExam);
          break;
        default:
          this.updateProgressStatus(aaExam);
          archiveStatus.push(aaExam);
          break;
      }
    }
    return archiveStatus;
  }

  get inProgress(): any[] {
    return this._inProgress;
  }

  set inProgress(value: any[]) {
    this._inProgress = value;
  }

  get error(): any[] {
    return this._error;
  }

  set error(value: any[]) {
    this._error = value;
  }

  private processError(aaExam) {
    if (this._error.indexOf(aaExam.examCkey) < 0) {
      this._error.push(aaExam.examCkey);
      if (this._inProgress.indexOf(aaExam.examCkey) >= 0) {
        this._inProgress.splice(this._inProgress.indexOf(aaExam.examCkey), 1);
      }
    }
  }

  private updateProgressStatus(aaExam) {
    if (this._inProgress.indexOf(aaExam.examCkey) >= 0) {
      this._inProgress.splice(this._inProgress.indexOf(aaExam.examCkey), 1);
    } else if (this._error.indexOf(aaExam.examCkey) >= 0) {
      this._error.splice(this._error.indexOf(aaExam.examCkey), 1);
    }
  }
}
